import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/AuthContext';

export default function SignInPage() {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (!email.trim() || !password) {
      setError('Please enter your email and password.');
      return;
    }
    setSubmitting(true);
    try {
      await signIn(email, password);
      navigate('/home', { replace: true });
    } catch (err) {
      setError(err.message || 'Sign in failed.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ backgroundColor: '#FBF6EF' }}>
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-6">
          <img src="/brand/logo-round.png" alt="Heritage Compass" className="w-20 h-20 rounded-full" data-testid="signin-logo" />
        </div>
        <h1 className="text-3xl font-extrabold mb-1" style={{ color: '#5B2D1F' }}>Welcome back</h1>
        <p className="text-base mb-6" style={{ color: '#4B6B79' }}>
          Sign in to continue with Heritage Compass.
        </p>

        {error && (
          <div data-testid="signin-error" className="p-4 rounded-xl border mb-4" style={{ backgroundColor: '#FCE7EA', borderColor: '#B0303A' }}>
            <p className="font-semibold" style={{ color: '#B0303A' }}>{error}</p>
          </div>
        )}

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label htmlFor="signin-email" className="block text-sm font-semibold mb-1" style={{ color: '#0F2A35' }}>Email</label>
            <input
              id="signin-email"
              data-testid="signin-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              autoComplete="email"
              className="w-full px-4 py-3 rounded-xl border text-base outline-none focus:ring-2"
              style={{ borderColor: '#D7E2E8', backgroundColor: '#FFFFFF' }}
            />
          </div>
          <div>
            <label htmlFor="signin-password" className="block text-sm font-semibold mb-1" style={{ color: '#0F2A35' }}>Password</label>
            <input
              id="signin-password"
              data-testid="signin-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="At least 8 characters"
              autoComplete="current-password"
              className="w-full px-4 py-3 rounded-xl border text-base outline-none focus:ring-2"
              style={{ borderColor: '#D7E2E8', backgroundColor: '#FFFFFF' }}
            />
          </div>
          <button
            type="submit"
            data-testid="signin-submit-btn"
            disabled={submitting}
            className="w-full py-4 rounded-xl text-lg font-extrabold text-white transition-opacity hover:opacity-90 disabled:opacity-50"
            style={{ backgroundColor: '#D77A52' }}
          >
            {submitting ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

        <p className="text-center mt-6" style={{ color: '#4B6B79' }}>
          New here?{' '}
          <Link to="/signup" data-testid="signin-go-signup" className="font-bold" style={{ color: '#D77A52' }}>
            Create an account
          </Link>
        </p>
      </div>
    </div>
  );
}
